import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { PwaService } from 'src/app/core/services/pwa/pwa.service';
import { DeviceService, OS } from 'src/app/core/services/device/device.service';
import { Observable } from 'rxjs/internal/Observable';
import { KeepOfflineService } from 'src/app/core/services/keep-offline/keep-offline.service';
import { timeout } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {

  private http = inject(HttpClient);
  private pwaService = inject(PwaService);
  private deviceService = inject(DeviceService);
  private keepOfflineService = inject(KeepOfflineService);

  public getAppSettingsFromJson(): Observable<AppSettings> {
    return this.http.get<AppSettings>('assets/appsettings.json');
  }

  public configureApplicationSettings(): Promise<void>{
    return new Promise<void>((resolve, reject) => {
      console.log('Configuring application settings...');
      if (environment.production && environment.deploymentType == 'onPremise') {
        let request$ = this.getAppSettingsFromJson();
        if(this.pwaService.isPwa() && this.deviceService.getOS() == OS.iOS){
          request$ = request$.pipe(timeout(2000));
        }
        request$.subscribe({
          next: async (settings) => {
            this.keepOfflineService.saveDataInIndexedDb('assets/appsettings.json', settings);
            this.loadAppSettings(settings);
            resolve();
          },
          error: (err) => {
            console.error('configureApplicationSettings failed', err);
            resolve();
          },
        });
      } else {
        resolve();
      }
    });
  }

  public loadAppSettings(settings: AppSettings): void {
    if (settings && settings.deploymentType == 'onPremise') {
      environment.port = settings.port.toString();
      environment.deploymentType = settings.deploymentType;
      environment.idpUri = settings.identityProviderURI;
      environment.apiUri = settings.api;
      environment.apiAiUri = settings.apiAiUri;
      environment.tenant = settings.tenant;
      environment.settingsUri = settings.settingsUri;
      environment.sentryDsn = settings.sentryDsn;
      environment.sentryTraceSampleRate = settings.sentryTraceSampleRate;
      environment.sentryReplaySampleRate = settings.sentryReplaySampleRate;
      environment.sentryReplayErrorsSampleRate = settings.sentryReplayErrorsSampleRate;
      environment.sentryTracePropagationTargets = settings.sentryTracePropagationTargets;
      environment.sentryEnabled = settings.sentryEnabled ? 'true' : 'false';
    }
  }
}

export type AppSettings = {
  port: number,
  deploymentType: 'cloud' | 'onPremise',
  identityProviderURI: string,
  api: string,
  apiAiUri: string,
  settingsUri: string,
  tenant: string,
  sentryDsn: string,
  sentryTraceSampleRate: string,
  sentryReplaySampleRate: string,
  sentryReplayErrorsSampleRate: string,
  sentryTracePropagationTargets: string,
  sentryEnabled: boolean,
}
